import { Box, Card, CardContent, Typography, Grid, TextField, MenuItem, Select, FormControl, InputLabel } from "@mui/material";


const InfoCard = ({ title, children }) => (
    <Card variant="outlined" sx={{ mb: 3 }}>
        <CardContent>
            <Box sx={{ display: 'flex', alignItems: 'center', mb: 2 }}>
                <Typography variant="h6" sx={{ fontSize: '1rem', fontWeight: 'bold' }}>{title}</Typography>
            </Box>
            {children}
        </CardContent>
    </Card>
);

const BookingEditForm = ({ booking, onChange }) => {
    
  return (
    <Box>
        {/* Row 1: Personal & Org */}
        <Grid container spacing={3}>
            <Grid item xs={12} md={6}>
                <InfoCard title="Personal Information">
                    <Grid container spacing={2}>
                        <Grid item xs={6}>
                            <Typography variant="caption" color="text.secondary">CLIENT NAME</Typography>
                            <Typography variant="body1">{booking.clientName}</Typography>
                        </Grid>
                        <Grid item xs={6}>
                            <Typography variant="caption" color="text.secondary">EMAIL ADDRESS</Typography>
                            <Typography variant="body1">{booking.clientEmail}</Typography>
                        </Grid>
                    </Grid>
                </InfoCard>
            </Grid>
            <Grid item xs={12} md={6}>
                 <InfoCard title="Organization Information">
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Typography variant="body2" color="text.secondary">No Organization Data (Placeholders)</Typography>
                        </Grid>
                    </Grid>
                </InfoCard>
            </Grid>
        </Grid>

        {/* Row 2: Service & Booking Info + Status */}
        <InfoCard title="Service & Booking Information">
            <Grid container spacing={2} alignItems="center">
               <Grid item xs={12} md={3}>
                    <Typography variant="caption" color="text.secondary">CONSULTANT NAME</Typography>
                    <Typography variant="body1">{booking.assignedEmployeeName || 'Unassigned'}</Typography>
               </Grid> 
               <Grid item xs={12} md={3}>
                    <Typography variant="caption" color="text.secondary">BOOKING DATE</Typography>
                    <Typography variant="body1">{booking.bookingDate}</Typography>
               </Grid> 
               <Grid item xs={12} md={3}>
                    <Typography variant="caption" color="text.secondary">BOOKING TIME SLOT</Typography>
                    <Typography variant="body1">{booking.timeLabel}</Typography>
               </Grid> 
               <Grid item xs={12} md={3}>
                    <FormControl fullWidth size="small">
                        <InputLabel>Booking Status</InputLabel>
                        <Select
                            value={booking.status}
                            label="Booking Status"
                            onChange={(e) => onChange('status', e.target.value)}
                        >
                            <MenuItem value="confirmed">Confirmed</MenuItem>
                            <MenuItem value="cancelled">Cancelled</MenuItem>
                            <MenuItem value="pending">Pending</MenuItem>
                            <MenuItem value="unanswered">Unanswered</MenuItem>
                        </Select>
                    </FormControl>
               </Grid> 
            </Grid>
            
            <Box sx={{ mt: 3 }}>
                <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>NOTES</Typography>
                <TextField 
                    fullWidth 
                    multiline 
                    rows={3} 
                    value={booking.notes} 
                    onChange={(e) => onChange('notes', e.target.value)}
                    variant="outlined"
                />
            </Box>
        </InfoCard>
    </Box>
  );
};

export default BookingEditForm;
